<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Tags">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="12">
                <div class="form-label-group">
                  <b-form-input
                    id="id"
                    placeholder="ID"
                    v-model="form._id"
                    disabled
                  />
                  <label for="id">ID</label>
                </div>
              </b-col> -->
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="name"
                    placeholder="Nome"
                    v-model="form.name"
                  />
                  <label for="name">Nome</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="code"
                    placeholder="Código"
                    v-model="form.code"
                  />
                  <label for="code">Código</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="12">
                  <b-button
                    v-if="form.origins.length > 0"
                    variant="flat-primary"
                    size="sm"
                    class="btn-close field-overlay mr-1"
                    @click="clearOrigins()"
                    v-b-tooltip.hover.top="'Limpar Origens'"
                  >
                  <feather-icon icon="TrashIcon" />
                </b-button>
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.origins"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    multiple
                    :options="origins"
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="12">
                <b-button
                  v-if="form.channels.length > 0"
                  variant="flat-primary"
                  size="sm"
                  class="btn-close field-overlay mr-1"
                  @click="clearChannels()"
                  v-b-tooltip.hover.top="'Limpar Canal'"
                >
                <feather-icon icon="TrashIcon" />
              </b-button>
                <div class="form-label-group">
                  <label for="origin-list">Canal</label>
                  <b-form-group label="Canal" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.channels"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    multiple
                    :options="channels"
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="12">
                <b-button
                  v-if="form.subjects.length > 0"
                  variant="flat-primary"
                  size="sm"
                  class="btn-close field-overlay mr-1"
                  @click="clearSubjects()"
                  v-b-tooltip.hover.top="'Limpar Assuntos'"
                >
                <feather-icon icon="TrashIcon" />
              </b-button>
                <div class="form-label-group">
                  <label for="origin-list">Assuntos</label>
                  <b-form-group label="Assuntos" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.subjects"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    multiple
                    :options="subjects"
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="12">
                <b-button
                  v-if="form.contents.length > 0"
                  variant="flat-primary"
                  size="sm"
                  class="btn-close field-overlay mr-1"
                  @click="clearContents()"
                  v-b-tooltip.hover.top="'Limpar Conteúdos'"
                >
                <feather-icon icon="TrashIcon" />
              </b-button>
                <div class="form-label-group">
                  <label for="origin-list">Conteúdos</label>
                  <b-form-group label="Conteúdos" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.contents"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    multiple
                    :options="contents"
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="12">
                <b-button
                  v-if="form.categories.length > 0"
                  variant="flat-primary"
                  size="sm"
                  class="btn-close field-overlay mr-1"
                  @click="clearCategories()"
                  v-b-tooltip.hover.top="'Limpar Categorias'"
                >
                <feather-icon icon="TrashIcon" />
              </b-button>
                <div class="form-label-group">
                  <label for="origin-list">Categorias</label>
                  <b-form-group label="Categorias" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.categories"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    multiple
                    :options="categories"
                    :closeOnSelect="false"
                    :reduce="(option) => option.id"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>

              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="active"
                    name="active"
                    v-model="form.active"
                  >
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="onSubmit"
                >
                  Enviar
                </b-button>
                <b-button variant="danger" class="mr-1" @click="onBackPage">
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
  VBTooltip
} from "bootstrap-vue";
import userCoreService from "@/providers/userCoreService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import vSelect from "vue-select";
import AppConstants from '@/appConstants';

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {},
  data() {
    return {
      dataID: null,
      originModel: null,
      origins: [],
      channels: [],
      subjects: [],
      contents: [],
      categories: [],
      form: {
        _id: "",
        name: "",
        code: "",
        active: true,
        origins: "",
        channels: "",
        subjects: "",
        contents: "",
        categories: "",
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo Núcleos de Usuário');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.loadData();
  },
  watch: {
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Novo Núcleos de Usuário');
      }
    },
    "form.origins"(val) {
      if (val.findIndex(item => item.id == AppConstants.DROPDOWN_ALL_OPTION.id) >= 0) {
        this.form.origins = [];
        this.form.origins = JSON.parse(JSON.stringify(this.origins));
        this.form.origins.shift();
      }
      if (val.length > 0) {
        this.loadChannel();
      }
    },
    "form.channels"(val) {
      if (val.findIndex(item => item.id == AppConstants.DROPDOWN_ALL_OPTION.id) >= 0) {
        this.form.channels = [];
        this.form.channels = JSON.parse(JSON.stringify(this.channels));
        this.form.channels.shift();
      }
      if (val.length > 0) {
        this.loadSubjects();
      }
    },
    "form.subjects"(val) {
      if (val.findIndex(item => item.id == AppConstants.DROPDOWN_ALL_OPTION.id) >= 0) {
        this.form.subjects = [];
        this.form.subjects = JSON.parse(JSON.stringify(this.subjects));
        this.form.subjects.shift();
      }
      if (val.length > 0) {
        this.loadContents();
      }
    },
    "form.contents"(val) {
      if (val.findIndex(item => item.id == AppConstants.DROPDOWN_ALL_OPTION.id) >= 0) {
        this.form.contents = [];
        this.form.contents = JSON.parse(JSON.stringify(this.contents));
        this.form.contents.shift();
      }
    },
    "form.categories"(val) {
      if (val.findIndex(item => item == AppConstants.DROPDOWN_ALL_OPTION.id) >= 0) {
        this.form.categories = [];
        this.form.categories = JSON.parse(JSON.stringify(this.categories.map(item => item.id)));
        this.form.categories.shift();
      }
    },
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    clearOrigins() {
      this.form.origins = [];
    },
    clearChannels() {
      this.form.channels = [];
    },
    clearSubjects() {
      this.form.subjects = [];
    },
    clearContents() {
      this.form.contents = [];
    },
    clearCategories() {
      this.form.categories = [];
    },
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_USER_CORE);
    },
    onSubmit() {
      userCoreService
        .registerUserCore(this.form, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getUserCoreDetails() {
      const params = new URLSearchParams();
      userCoreService
        .getUserCoreDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.name = res.name;
          this.form.code = res.code;
          this.form.origins = res.origins;
          this.form.channels = res.channels;
          this.form.subjects = res.subjects;
          this.form.contents = res.contents;
          this.form.categories = res.categories;
          this.form.active = res.active;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      this.origins = [];
      
      dropdownService
        .getAllOrigin(new URLSearchParams())
        .then((res) => {
          this.origins = res;
          this.origins.unshift(AppConstants.DROPDOWN_ALL_OPTION);
          this.loadCategories();
          if (this.isUpdate) {
            this.getUserCoreDetails();
          }
        })
        .catch((err) => console.log(err));
    },
    loadChannel() {
      this.channels = [];
      this.subjects = [];
      this.contents = [];
      const params = new URLSearchParams();
      params.append(
          "origins",
          this.form.origins.map((item) => item.id).join(",")
      );
      dropdownService
        .getChannelByOrigin(params)
        .then((res) => {
          this.channels = res;
          this.channels.unshift(AppConstants.DROPDOWN_ALL_OPTION);
        })
        .catch((err) => console.log(err));
    },
    loadSubjects() {
      this.subjects = [];
      this.contents = [];
      const params = new URLSearchParams();
      params.append("origins", this.getOriginWithChannelOrigin().join(","));
      dropdownService
        .getAllSubjects(params)
        .then((res) => {
          this.subjects = res;
          this.subjects.unshift(AppConstants.DROPDOWN_ALL_OPTION);
        })
        .catch((err) => console.log(err));
    },
    loadContents() {
      this.contents = [];
      const params = new URLSearchParams();
      params.append("origins", this.getOriginWithChannelOrigin().join(","));
      params.append("subject",this.form.subjects.map((item) => item.id).join(","));
      dropdownService
        .getContentBySubject(params)
        .then((res) => {
          this.contents = res;
          this.contents.unshift(AppConstants.DROPDOWN_ALL_OPTION);
        })
        .catch((err) => console.log(err));
    },
    loadCategories() {
      this.categories = [];
      const params = new URLSearchParams();
      dropdownService
        .getUserCategoriesField(params)
        .then((res) => {
          this.categories = res;
          this.categories.unshift(AppConstants.DROPDOWN_ALL_OPTION);
        })
        .catch((err) => console.log(err));
    },
    getOriginWithChannelOrigin() {
      let originList = this.form.origins.map((item) => item.id);
      if (this.form.channels) {
        const channelFiltered = this.form.channels.filter(
            (item) => item.origin
        );
        if (channelFiltered.length > 0) {
          return originList.concat(channelFiltered.map((item) => item.origin));
        }
      }
      return originList;
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    vSelect
    // BInputGroup,
    // BInputGroupAppend,
    // BListGroup,
    // BListGroupItem,
    // BCardText,
    // BFormTags,
    // BFormTag,
    // BFormSelect
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>